import React from 'react';
import { connect } from 'react-redux';
import {
  LocalForm,
  Control,
  actions
} from 'react-redux-form';
// import { capitalize } from '../helpers'
import Errors from './Errors'

import { is_numeric } from '../helpers'
import { set_counters } from '../actions'


const mapStateToProps = state => {
  return {
    counters: state.entry.counters,
    fetching: state.entry.fetching,
    added_columns: state.entry.added_columns,
    report_id: state.entry.report_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateCounters: (id, counters) => dispatch( set_counters(id, counters) )
  }
}

class ConnectedManageCounters extends React.Component {
  constructor() {
    super()
    this.state = {
      selector: null,
      currentSelection: '',
      numberValid: true,
      counters: []
    }
  }

  handleSelect(e) {
    this.setState({currentSelection: e.target.value})
  }

  handleSubmit(values) {
    const counters = this.state.counters.filter( c => c.key !== values.key )
    this.setState({
      counters: [...counters, values]
    })
  }

  handleUpdate(form) {
    const { value } = form
    console.log(value)
    this.setState({
      numberValid: value.pristine || value.valid
    })
  }

  removeCounter(key) {
    this.setState({
      counters: this.state.counters.filter( c=> c.key !== key )
    })
  }

  updateCounters() {
    this.props.hide()
    this.props.updateCounters(this.props.report_id, this.state.counters)
  }

  resetCounters() {
    this.setState({
      counters: this.props.counters
    })
  }

  updateInlineCounter(key, value) {
    this.setState({
      counters: this.state.counters.map( counter => {
        if (counter.key === key) {
          return {key: key, value: value}
        }
        return counter
      })
    })
  }

  componentDidMount() {
    const elem = document.getElementById('selectItem')
    const selector = window.M.FormSelect.init(elem);
    this.setState({selector: selector})
    this.setState({counters: this.props.counters})
  }

  componentDidUpdate(prevProps, prevState) {
    const { counters } = this.props
    if ( (this.props.fetched && !prevProps.fetched) || (this.props.added_columns && !prevProps.added_columns)) {
      this.setState({counters: counters})
    }
    // const { columns, removing_column, hide, resetForm, resetErrors, isHidden } = this.props
    // const prevColumns = prevProps.columns
    // const prevRemovingColumn = prevProps.removing_column
    // const wasHidden = prevProps.isHidden
    //
    // if (isHidden && !wasHidden) {
    //   resetForm()
    //   resetErrors()
    // } else {
    //
    //   if ( JSON.stringify(columns) !== JSON.stringify(prevColumns) ) {
    //     const fs = this.state.selector
    //     fs.destroy()
    //     const elem = document.getElementById('removeItem')
    //     const selector = window.M.FormSelect.init(elem);
    //     this.setState({selector: selector})
    //   }
    //   if ( removing_column !== prevRemovingColumn ) {
    //     if ( prevRemovingColumn ) {
    //       hide()
    //       resetForm()
    //       resetErrors()
    //     }
    //   }
    //
    // }

  }

  componentWillUnmount() {
    // const { resetForm, resetErrors } = this.props
    // resetForm()
    // resetErrors()
  }

  resetForm() {
    // const { resetForm, resetErrors } = this.props
    // resetForm()
    // resetErrors()
  }


  render() {
    const { columns, isHidden, hide } = this.props
    if ( columns === undefined ) {
      return ''
    }
    const fixed = ["title","new_title","meta_description","new_meta_description", "h1", "new_h1"]
    return (
      <div className={isHidden ? 'hide' : ''}>
        <div className="col s4 l4 xl4 z-depth-2 pad10">
          <LocalForm
            model="counters"
            style={{display: 'inline', width: '100%'}}
            initialState={{value: '0'}}
            onSubmit = {this.handleSubmit.bind(this)}
            onUpdate = {this.handleUpdate.bind(this)}
          >
            <div className="input-field" style={{marginBottom: 12}}>
              <label htmlFor="selectItem" className="active">Select a column to manage its counter.</label>
              <Control.select id="selectItem" model= "counters.key" onChange={this.handleSelect.bind(this)}>
                <option value='' style={{color: 'pink'}}>Select a column</option>
                {
                  columns.map( (column, index) => {
                    return (
                      <option value={column.key} key={index}>{column.name}</option>
                    )
                  })
                }
              </Control.select>
            </div>

            <div className="input-field" style={{marginBottom: 12}}>
              <label htmlFor="valueItem" className="active">Threshold Value</label>
              <Control.text
                id="valueItem"
                model="counters.value"
                required
                validators={{
                  required: val=> is_numeric(val, true)
                }}
              />
              <span className="helper-text" style={{color: '#e53935'}}>{this.state.numberValid ? '' : 'Integer >= 0'}</span>
            </div>

            <div className="input-field">
              <button
                type="submit"
                className="btn red darken-1 waves-effect waves-light pull-right"
                disabled={this.state.currentSelection === ''}
              ><i className="material-icons right">navigate_next</i>Set Value </button>
            </div>

          </LocalForm>
        </div>
        <div className="col s8 l8 xl8 pad10">
          { this.state.counters.length > 0 && (
            <div className="pl-12">
              <div className="row counterRow">
                <div className="col s1 l1 xl1"></div>
                <div className="col s6 l6 xl6 strong">Column</div>
                <div className="col s4 l4 xl4 strong">Value</div>
              </div>
              {this.state.counters.sort((a,b) => a.key > b.key).map( c => {
                return (
                  <div className="row counterRow" key={c.key}>
                    { fixed.indexOf(c.key) >= 0 ? <div className="col s1 l1 xl1" /> : (
                      <div className="col s1 l1 xl1"><i className="material-icons c-red" title="Remove Filter" style={{cursor: 'pointer'}}onClick={e => {
                        e.preventDefault()
                        this.removeCounter(c.key)
                      }}>cancel</i></div>
                    )}
                    <div className="col s6 l6 xl6">{columns.find( l => l.key === c.key ).name}</div>
                    <div className="col s4 l4 xl4 inline-input" title="Click to edit">
                      <input value={c.value} type="text" onChange={e=> {
                        this.updateInlineCounter(c.key, e.target.value)
                      }} onClick={e => {
                        e.target.select()
                      }}/>
                    </div>
                  </div>
                )
              })}
              {
                (JSON.stringify(this.props.counters) !== JSON.stringify(this.state.counters)) && (
                  <div className="row">
                    <a
                      href=''
                      className="btn red darken-1 waves-effect waves-light pull-right mr-10"
                      onClick={e => {
                        e.preventDefault()
                        this.updateCounters()
                      }}
                    ><i className="material-icons right">navigate_next</i>Update Counters </a>

                    <a
                      href=''
                      className="btn red darken-1 waves-effect waves-light pull-right"
                      onClick={e => {
                        e.preventDefault()
                        this.resetCounters()
                      }}
                    >RESET </a>
                  </div>
                )
              }
            </div>
          )}
        </div>
      </div>
    )
  }

}

const ManageCounters = connect(mapStateToProps, mapDispatchToProps)(ConnectedManageCounters)

export default ManageCounters



// WEBPACK FOOTER //
// ./src/js/components/ManageCounters.js